// @flow
import type { GlobalState } from "../../lib/types";
import { getLastMessageNumber, getMessagesHistory } from "../../store";
import { savedUserFirstNameKey } from "../../lib/constants";

/**
 * Get error for the user input.
 * @param messageNum - number of the message
 * @param state
 * @returns {string}
 */
export const getErrorMessage = (messageNum: number, state: GlobalState) => {
  return state.inputErrors[messageNum];
};
/**
 * Does the last message has error?
 * @param state
 * @returns {boolean}
 */
export const doesLastMessageHasError = (state: GlobalState) => {
  return Boolean(getErrorMessage(getLastMessageNumber(state), state));
};
/**
 * Get number of the message user is currently editing.
 * @param state
 */
export const getEditingMessageNum = (state: GlobalState) => {
  return state.editingMessageNum;
};
/**
 * Return true if currently entering answer for the very last message in the history.
 * @param state
 * @returns {boolean}
 */
export const getIsEditingLastMessage = (state: GlobalState) => {
  const editingMessageNum = getEditingMessageNum(state);
  const messagesHistory = getMessagesHistory(state);
  return messagesHistory.length - 1 <= editingMessageNum;
};
/**
 * Tell if user is editing a message from the history opposite to the very last user input message.
 * @param state
 * @returns {boolean}
 */
export const getWorkWithHistory = (state: GlobalState) => {
  return state.workWithHistory;
};
/**
 * Get user's first name.
 */
export const getUserFirstName = (state: GlobalState) => {
  let fallback = localStorage.getItem(savedUserFirstNameKey) || "";
  fallback = fallback.split(" ")[0];
  try {
    return state.userData.first_name.split(" ")[0] || fallback;
  } catch (e) {
    return fallback;
  }
};
